/**
 * Mixin xử lý group dữ liệu của grid view/edit
 */

import commonFn from '@/commons/commonFunction.js';
import { shallowReactive } from 'vue';
export const gridGroupData = {
  props: {
    /**
     * Trường để nhóm dữ liệu
     */
    groupField: { default: null, type: Array },
    /**
     * Có hiển thị summary trên dòng group text không
     */ groupSumable: { type: Boolean, default: false },
    /**
     * Dữ liệu sum sẽ lấy từ server
     */ groupSumRemote: { type: Array, default: null },
    /**
     * custom lại cách nhóm dữ liệu
     */ customGroupField: { type: Object, default: {} },
    /**
     * custom lại text nhóm
     */
    buildGroupTextCustom: { type: Function, default: null },
    /**
     * custom lại cách đánh SortOrder
     */
    rebuildSortOrderCustom: { type: Function, default: null },
    /**
     * Thêm sort cho GroupField
     */
    sortTypeGroupField: { type: String, default: 'asc' },
    /**
     * Trường dùng để sắp xếp
     */
    sortValueGroupField: { type: String, default: null }
  },
  data() {
    return {
      /**
       * Danh sách các group expanded
       */
      groupExpand: []
    };
  },
  computed: {
    groupData() {
      const groupField = this.groupField;
      const datax = this.datax;
      const me = this;
      const seperatorChar = '=+*';
      const map = {};
      if (groupField && groupField.length > 0 && this.columnx.length > 0) {
        const length = groupField.length;
        const summaryCols = this.columnx.filter(x => x.summaryType);

        //Cộng tổng
        //TODO=> Có thể thêm các loại summary khác, xử lý sau
        const plusSummary = (rowParent, row) => {
          summaryCols.forEach(x => {
            if (!rowParent[x.dataField]) {
              rowParent[x.dataField] = 0;
            }
            rowParent[x.dataField] += row[x.dataField];
          });
        };

        const columnMap = {};
        this.columns.forEach(x => (columnMap[x.dataField] = x));

        groupField.forEach((field, index, arr) => {
          datax.forEach(function(curRow) {
            //Tính toán key
            const key = arr.reduce((p, c, i) => {
              if (i <= index) {
                return p + `${curRow[c] || ''}${seperatorChar}`;
              }
              return p;
            }, '');

            const newObj = shallowReactive({
              groupLevel: index + 1,
              isGroup: true,
              caption: `${columnMap[field]?.caption ||
                me.customGroupField[field]}: ${curRow[field] || ''}`,
              [me.idField]: commonFn.generateUUID(),
              expanded: true
            });

            summaryCols.forEach(x => {
              newObj[x.dataField] = curRow[x.dataField];
            });
            if (!map[key]) {
              map[key] = newObj; // create a copy of o

              const parentKey = key.replace(
                `${curRow[field] || ''}${seperatorChar}`,
                ''
              );

              //Thực hiện push các node vào parent đã có nếu k phải root
              if (parentKey) {
                if (Array.isArray(map[parentKey].childNodes)) {
                  map[parentKey].childNodes.push(map[key]);
                } else {
                  map[parentKey].childNodes = [map[key]];
                }
              }
            } else {
              plusSummary(map[key], curRow);
            }

            //Nếu là item field cuối cùng thì thực hiện thêm node list là row vào data
            if (index === length - 1) {
              if (map[key].childNodes) {
                map[key].childNodes.push(curRow);
              } else {
                map[key].childNodes = [curRow];
              }
            }
          });
        });

        const objVals = Object.values(map);
        const rootLevel = 1;
        const roots = objVals
          .filter(x => x.groupLevel === rootLevel)
          .sortObject(...groupField);

        const dataTree = commonFn.getBodyData(
          roots,
          true,
          rootLevel,
          'childNodes',
          true
        );
        return dataTree;
        //TODO
      }

      return [];
    },
    /**
     * Group có rowspan
     * @returns
     */
    groupDataRowSpan() {
      const groupField = this.groupField;
      const datax = this.datax;
      const me = this;
      const seperatorChar = '=+*';

      if (groupField && groupField.length > 0) {
        //Thực hiện group theo từng field 1 để sắp xếp và tính toán rowspan
        const calcRowspan = (data, field, indexField) => {
          const map = new Map();
          data.forEach(function(curRow) {
            //Tính toán key
            const keyRowSpan = `rowspan-${field}`;
            delete curRow[keyRowSpan];
            const key = groupField.reduce((p, c, i) => {
              if (i <= indexField) {
                return p + `${curRow[c] || ''}${seperatorChar}`;
              }
              return p;
            }, '');

            if (map.has(key)) {
              const items = map.get(key);
              const first = items[0];
              first[keyRowSpan] += 1;
              items.push(curRow);
            } else {
              curRow[keyRowSpan] = 1;
              map.set(key, [curRow]);
            }
          });

          return [...map.values()].reduce((pre, cur) => {
            return pre.concat(cur);
          }, []);
        };

        let dataTemp = datax;
        groupField.forEach((field, index) => {
          dataTemp = calcRowspan(dataTemp, field, index);
        });
        return dataTemp;
      }
      return [];
    },
    columnSumary() {
      const columnx = this.columnx;
      const colSums = [{ dataField: 'caption' }];
      let plusCol = 0;

      const me = this;
      //xử lý cột selection và số thứ tự
      if (me.serial) {
        plusCol++;
      }
      if (me.multiple) {
        plusCol++;
      }
      columnx.forEach((column, index) => {
        if (column.summaryType || colSums.length > 1) {
          const colSumary = Object.assign({}, column);
          colSums.push(colSumary);
          if (!colSums[0].groupColspan) {
            colSums[0].groupColspan = index + plusCol;
          }
        }
      });

      return colSums;
    }
  },
  methods: {
    /**
     * Sau khi sort group cần gán lại số thứ tự
     */
    rebuildSortOrder(res) {
      let me = this;
      if (typeof me.rebuildSortOrderCustom === 'function') {
        me.rebuildSortOrderCustom(res);
      } else {
        let currentPage = (me.currentPage - 1) * me.pageSize + 1;
        res
          .flatMap(x => x.datax)
          .map((x, idx) => (x.SortOrder = currentPage + idx));
      }
    },
    /**
     * Xử lý summary của group
     * xử lý cho các trường kiểu số
     */
    processGroupSummary(groups) {
      const me = this;
      if (!me.groupSumable) {
        groups.forEach(item => {
          item.colspan = me.columnx.length + 1; // cộng 1 để colspan thêm cột stt
        });
      } else {
        //xử lý lấy các cột sẽ sum
        let cols = [];
        let firstIndexSumColumn = null;
        let columnLockNumber = 0; // tổng số cột bị ghim
        me.columnx.forEach((col, i) => {
          if (col.lock) {
            columnLockNumber++;
          }

          if (col.summaryType) {
            if (!firstIndexSumColumn) {
              firstIndexSumColumn = i;
            }
            cols.push({
              index: i,
              dataField: col.dataField,
              formatType: col.formatType,
              summaryType: col.summaryType,
              align: col.align
            });
          }

          // switch (col.formatType) {
          //   case me.$ms.constant.FormatType.Amount:
          //   case me.$ms.constant.FormatType.QuantityConvert:
          //   case me.$ms.constant.FormatType.Quantity:
          //   case me.$ms.constant.FormatType.Number:
          //     if (col.dataField != "Sortorder") {
          //       if (!firstIndexSumColumn) {
          //         firstIndexSumColumn = i;
          //       }
          //       cols.push({
          //         index: i,
          //         dataField: col.dataField,
          //         formatType: col.formatType,
          //         summaryType: col.summaryType,
          //       });
          //     }
          //     break;
          // }
        });

        //nếu không có cột sum nào -> colspan all
        if (cols.length === 0) {
          groups.forEach(item => {
            item.colspan = me.columnx.length;
          });
        } else {
          //xử lý tính sum cho từng group
          groups.forEach(group => {
            let sum = {};

            if (me.groupSumRemote && me.groupSumRemote.length > 0) {
              for (let i = 0; i < me.groupSumRemote.length; i++) {
                let gs = me.groupSumRemote[i];
                if (gs[me.groupField] === group.value) {
                  sum = gs;
                  break;
                }
              }
            } else {
              // me.getSumValue(col)
              cols.forEach(col => {
                if (col.summaryType) {
                  sum[col.dataField] = me.getSumValue(
                    col.summaryType,
                    group.datax,
                    col.dataField
                  );
                }
              });
            }

            let colspan = 1;
            if (columnLockNumber > 0) {
              colspan = Math.min(columnLockNumber, firstIndexSumColumn);
            } else {
              colspan = firstIndexSumColumn;
            }

            //column
            group.columnx = [];
            if (colspan < cols[0].index) {
              group.columnx.push({
                colspan: cols[0].index - colspan,
                empty: true
              });
            }

            for (let i = cols[0].index; i < me.columnx.length; i++) {
              let map = null;
              for (let j = 0; j < cols.length; j++) {
                if (cols[j].index === i) {
                  map = cols[j];
                  break;
                }
              }

              if (map) {
                group.columnx.push({
                  formatType: map.formatType,
                  value: sum[map.dataField],
                  field: map.dataField,
                  align: map.align
                });
              } else {
                group.columnx.push(null);
              }
            }

            //xử lý cột selection và số thứ tự
            if (me.serial) {
              colspan++;
            }
            if (me.multiple) {
              colspan++;
            }

            if (colspan > 1) {
              group.colspan = colspan;
            }
          });
        }
      }
    },
    /**
     * Xử lý summary cho group
     * @param {*} op : toán tử ~ summaryType (hoặc xem xét tách groupSumType)
     * @param {*} data : dữ liệu gốc
     * @param {*} field: trường thông tin
     */

    getSumValue(op, data, field) {
      const me = this;
      let res = null;
      switch (op) {
        case me.$ms.constant.SummaryType.Sum:
          res = 0;
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            res += value;
          }
          break;
        case me.$ms.constant.SummaryType.Min:
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            if (res == null) {
              res = value;
            } else if (value < res) {
              res = value;
            }
          }
          break;
        case me.$ms.constant.SummaryType.Max:
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            if (res == null) {
              res = value;
            } else if (value > res) {
              res = value;
            }
          }
          break;
        case me.$ms.constant.SummaryType.Avg:
          res = 0;
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            res += value;
          }

          res = res / data.length;
          break;
      }

      return res;
    },
    /**
     * build text hiển thị của column
     */

    buildGroupText(group, index, column) {
      const me = this;
      let text = me.$ms.format.formatData(group.value, {
        formatType: column ? column.formatType : 0,
        enumName: column ? column.enum : null
      });

      // return text;
      let resultText = [
        index + 1,
        '. ',
        text == '-' ? 'Khác' : text,
        ' (',
        group.datax.length,
        ')'
      ].join('');

      if (typeof me.buildGroupTextCustom === 'function') {
        try {
          resultText = me.buildGroupTextCustom(
            group,
            index,
            column,
            text,
            resultText
          );
        } catch (ex) {
          console.errror(ex);
        }
      }

      return resultText;
    },
    /**
     * collapse/expand group
     */
    toggleGroup(group) {
      const me = this,
        value = group.value;
      if (me.groupExpand.indexOf(value) === -1) {
        me.groupExpand.push(value);
      } else {
        me.groupExpand.remove(value);
      }
    },
    /**
     * expand all group data
     */
    expandAll() {
      const me = this;
      if (me.groupData) {
        let gs = [];
        me.groupData.forEach(item => {
          gs.push(item.value);
        });
        me.groupExpand = gs;
      }
    },
    /**
     * expand dữ liệu mặc định sau khi render
     * expand nhóm đầu - để hiệu năng render tốt nhất
     */
    defaultExpand() {
      const me = this;
      me.expandAll();
      return;

      if (me.groupData) {
        let gs = [];
        if (me.groupData.length > 0) {
          gs.push(me.groupData[0].value);
        }
        me.groupExpand = gs;
      }
    },
    /**
     * collapse all group data
     */

    collapseAll() {
      const me = this;
      me.groupExpand = [];
    }
  }
};
